export interface GallerySlide {
  title: string
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Step-by-step technical progressions',
  'Technique breakdowns',
  'Directional diagrams',
  'Foot-position maps',
  'Correct-vs-incorrect comparisons',
  'Reaction and combination systems',
  'Coaching cue cards',
  'Error-correction tools',
  'Session structures',
  'Assessment sheets',
  'Training circuits',
  'Checklists and quick-reference tools',
]

export const gallerySlides: GallerySlide[] = [
  {
    title: 'Ko-uchi-gari → Ippon-seoi-nage — Step-by-Step Combination',
    src: 'https://cdn.magicpatterns.com/uploads/traYknHQqe5idWgLV4ifLb/Captura_de_pantalla_2026-09-24_194803.png',
    alt: 'Four-step visual breakdown of the Ko-uchi-gari to Ippon-seoi-nage combination with coaching cues',
  },
  {
    title: 'Judo Posture Foundations — Build the Body Position Before the Technique',
    src: 'https://cdn.magicpatterns.com/uploads/nVUcuZFpWM9CEe7kKdEGCf/Captura_de_pantalla_2026-09-24_194623.png',
    alt: 'Front and side posture diagrams of a judoka with correct versus incorrect posture checklist',
  },
  {
    title: 'See the Difference — No Kuzushi vs Effective Kuzushi',
    src: 'https://cdn.magicpatterns.com/uploads/pDfVHhMZz7HTKhwEHLyYRK/Captura_de_pantalla_2026-09-24_194526.png',
    alt: 'Three-panel comparison showing no real kuzushi, partial kuzushi and effective kuzushi with foot pressure maps',
  },
  {
    title: 'Session 01 — Kuzushi & Movement Foundation',
    src: 'https://cdn.magicpatterns.com/uploads/q4oxsKLBXD7BgLJ5kA1DD3/Captura_de_pantalla_2026-09-24_194423.png',
    alt: 'Complete 60-minute Judo session plan with time blocks, coach observation priorities and coaching cues',
  },
  {
    title: 'Combinations — The First Attack Creates the Second',
    src: 'https://cdn.magicpatterns.com/uploads/nodXXjLZyJxBF7VungV8oR/Captura_de_pantalla_2026-09-24_194348.png',
    alt: 'Combination system page showing attack plus uke reaction equals second attack, with four progression levels',
  },
  {
    title: 'De-ashi-barai — Common Errors & Corrections',
    src: 'https://cdn.magicpatterns.com/uploads/mnR9q6QbwD1qsaQGZD6v72/Captura_de_pantalla_2026-09-24_194203.png',
    alt: 'Correct versus incorrect comparisons of four common De-ashi-barai errors with correction notes',
  },
]
